// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-3BRz4";
var _3 = "header-1FEzc";
var _4 = "includedIcon-2HR-F";
var _5 = "content-3beQA";
var _6 = "oldVersion-3sfZJ";
var _7 = "container_loading-1Fjgg";
var _8 = "label-3-RBL";
var _9 = "label_aggregator-gZA_T";
var _a = "footer-2zrsM";
var _b = "info-2qxH0";
var _c = "price-3Pyy_";
var _d = "container_selected-2biiT";
var _e = "price__label-2jlJO";
var _f = "controls-2cs91";
var _10 = "change-HMrQe";
var _11 = "loading-1KDiC";
var _12 = "option__name-1s6gB";
var _13 = "option__price-y6619";
var _14 = "option__price_icon-1Rr_y";
var _15 = "option__download-13lSb";
var _16 = "option__iconIncluded-2SdsA";
var _17 = "scrollBody-A79yZ";
var _18 = "paper-1FdBh";
var _19 = "options-23BKk";
var _1a = "forAll-2zR2u";
var _1b = "money-2nPL7";
var _1c = "button-22wbY";
export { _1 as "__esModule", _2 as "container", _3 as "header", _4 as "includedIcon", _5 as "content", _6 as "oldVersion", _7 as "container_loading", _8 as "label", _9 as "label_aggregator", _a as "footer", _b as "info", _c as "price", _d as "container_selected", _e as "price__label", _f as "controls", _10 as "change", _11 as "loading", _12 as "option__name", _13 as "option__price", _14 as "option__price_icon", _15 as "option__download", _16 as "option__iconIncluded", _17 as "scrollBody", _18 as "paper", _19 as "options", _1a as "forAll", _1b as "money", _1c as "button" }
export default { "__esModule": _1, "container": _2, "header": _3, "includedIcon": _4, "content": _5, "oldVersion": _6, "container_loading": _7, "label": _8, "label_aggregator": _9, "footer": _a, "info": _b, "price": _c, "container_selected": _d, "price__label": _e, "controls": _f, "change": _10, "loading": _11, "option__name": _12, "option__price": _13, "option__price_icon": _14, "option__download": _15, "option__iconIncluded": _16, "scrollBody": _17, "paper": _18, "options": _19, "forAll": _1a, "money": _1b, "button": _1c }
